import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/cardiology/cardiologyOpinion";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	cardiology: {
		id: "ktx.cardiology_opinion.title",
		defaultMessage: "Kardiológiai vélemény"
	},
	result: {
		id: "ktx.cardiology_opinion.field.result",
		defaultMessage:
			"Eredmény (Kérjük ismert és kezelt szervkárosodás esetén mindenképpen töltse ki az űrlapot)"
	},
	description: {
		id: "ktx.bike_ergometry.field.description",
		defaultMessage: "Megjegyzés"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: resultMessages }
		}
	},
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: {
			type: "textarea",
			props: {}
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.description }] }
	]
};

export const node: LeafNode = {
	id: "ktx_cardiologyOpinion",
	value: {
		schemaId: "cardiologyOpinion",
		title: messages.cardiology,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
